import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import {NxButton} from '@nextbank/ui-components';
import styles from './CreditCheckPdfViewer.module.scss';

interface Base64PdfViewerProps {
  isOpen: boolean;
  onClose: () => void;
  base64Pdf: string;
  title: string;
}

const Base64PdfViewer: React.FC<Base64PdfViewerProps> = ({
  isOpen,
  onClose,
  base64Pdf,
  title
}) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!base64Pdf) return;

    // Convert base64 to Blob
    const base64WithPrefix = base64Pdf.startsWith('data:')
      ? base64Pdf 
      : `data:application/pdf;base64,${base64Pdf}`;

    // Extract the base64 data part (remove the prefix)
    const base64Data = base64WithPrefix.split(',')[1];

    if (!base64Data) {
      console.error('Invalid base64 data');
      return;
    }

    // Convert base64 to binary
    const binaryString = window.atob(base64Data);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Create Blob and URL
    const blob = new Blob([bytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    setBlobUrl(url);

    // Clean up the URL when component unmounts
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [base64Pdf]);

  if (!base64Pdf) return null;

  return (
    <Dialog fullWidth={true} open={isOpen} onClose={onClose}>
      <DialogContent className={styles.dialogContent}>
        <div className={styles.pdfContainer}>
          <iframe className={styles.pdfViewer} src={blobUrl || ''} allow="fullscreen" title={title} />
        </div>
      </DialogContent>
      <DialogActions>
        <NxButton onClick={onClose}>
          Close
        </NxButton>
      </DialogActions>
    </Dialog>
  );
};

export default Base64PdfViewer;
